import React from 'react';
import styles from './Settings.module.css';

const Settings = () => {
    return (
        <div className={styles.settingsContainer}>
             Settings
        </div>
    )
}

export default Settings;